module.exports = __webpack_public_path__ + "img/medal-exam.1968384c.svg";